import React from 'react'
import cx from 'classnames'

import s from './CircleLoader.scss'


export type CircleLoaderProps = {
  id?: string
  className?: string
  color?: 'brand' | 'white' | 'black'
  center?: boolean
}

const CircleLoader: React.FunctionComponent<CircleLoaderProps> = ({ id, className, color = 'brand', center }) => {
  const rootClassName = cx(className, s.loader, {
    [s[color]]: color,
    [s.center]: center,
  })

  return (
    <div id={id} className={rootClassName} />
  )
}


export default CircleLoader
